<template>
  <div class="page-content">
    <page-template ref="brandTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    components: {
      pageTemplate

    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [{
            label: '',
            type: 'input',
            prop: 'brandName',
            isFuzzy: true,
            placeholder: '品牌名称/品牌编码'
          },],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              span: 12,
              change: this.getBrandChange,
              url: api.system.seStore
            },
            {
              label: '品牌',
              type: 'select',
              prop: 'goodsBrandId',
              data: [],
              span: 12,
              //url: api.archives.brand
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '设置',
            code: 'set',
          },
          {
            label: '打印',
            code: 'print',
          },
          {
            label: '导出',
            code: 'export',
            callback: this.exportExcel
          }
        ],
        // 表格信息配置
        tableOptions: {
          showSummary: true,
          summaryColumns: ['goodsNum', 'payPrice', 'refundNum', 'refundPrice', 'giveNum', 'givePrice', 'totalMoney'],
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '门店名称',
              prop: 'storeName',
              width: '190',
              align: 'center'
            },
            {
              label: '门店编码',
              prop: 'storeCode',
              width: '100',
              align: 'center',
            },
            {
              label: '品牌名称',
              prop: 'brandName',
              width: '100',
              align: 'center',
            },
            {
              label: '品牌编码',
              prop: 'code',
              width: '100',
              align: 'center',
            },
            {
              label: '原零售价',
              prop: 'retailPrice',
              width: '90',
              align: 'center'
            },
            {
              label: '销售均价',
              prop: 'avgMoney',
              width: '90',
              align: 'center'
            },
            {
              label: '销售数量',
              prop: 'goodsNum',
              width: '90',
              align: 'center'
            },
            {
              label: '金额',
              prop: 'payPrice',
              width: '120',
              align: 'center'
            },
            {
              label: '退货数量',
              prop: 'refundNum',
              width: '90',
              align: 'center'
            },
            {
              label: '退货金额',
              prop: 'refundPrice',
              width: '120',
              align: 'center'
            },
            {
              label: '赠送数量',
              prop: 'giveNum',
              width: '90',
              align: 'center'
            },
            {
              label: '赠送金额',
              prop: 'givePrice',
              width: '120',
              align: 'center'
            },
            {
              label: '金额小计',
              prop: 'totalMoney',
              width: '120',
              align: 'center'
            }
          ],
          url: api.retail.brandSalesSummary
        },
      };
    },
    created() {
      this.setStore(this.searchOptions.complex);
      //this.setSupplier(this.searchOptions.complex);
      this.getBrand();
      this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, 40);
    },
    destroyed(){
      this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, 10);
    },
    methods: {
      getBrand() {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          this.$axios.fetchPost(api.archives.brand + '/list', {}).then(data => {
            if (data.code === 200) {
              this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
            }
          })
        }
      },
      getBrandChange(form) {
        form.goodsBrandId = '';
        this.$axios.fetchPost(api.archives.brand + '/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          }
        })
      },
      exportExcel() {
        let params = this.$refs["brandTemplate"].getCurrentParams();
        params.exportCode = "SoSalesBrandExport";
        this.$axios.fetchPost(api.store.summaryBrandExport, params).then(data => {
          if (data.code === 200) {
            const elink = document.createElement('a');
            elink.href = data.data;
            elink.click();
            this.loadingExt = false;
            this.$message({message: '导出成功', type: 'success'});
          } else {
            this.$message({message: '导出异常', type: 'error'});
          }
        })
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/store/sales/Brand.vue